import React from "react";
import { Route, Routes } from "react-router-dom";
// import { useSelector } from "react-redux";
import ListHomeVR from "../Components/Home VR/listHomeVR";


const HomeVRRoutes = () => {
  // const { admin } = useSelector((state) => state.admin || {});
  // const accessCode = admin?.data?.access_code || [];

  // const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
  // const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  return (
    <Routes>
      <Route path="/home_vr" element={<ListHomeVR />} />
      {/* <Route
        path="/home_banner_list"
        element={canAdd ? <HomeBannerList /> : <Navigate to="/dashboard" replace />}
      />
      <Route
        path="/home_banner/add"
        element={canAdd ? <AddHomeBanner /> : <Navigate to="/dashboard" replace />}
      /> */}
    </Routes>
  );
};

export default HomeVRRoutes;